import React from "react";

import { Dropdown } from "@packages/ds";

import useUniqueId from "Libs/useUniqueId";
import { sendPendoEventDropdownItem } from "Store/analytics/pendoFunctions";

interface ConsoleRadioItemProps
  extends Omit<React.ComponentProps<typeof Dropdown.RadioItem>, "ref"> {
  analyticId?: string;
}

const RadioItem = React.forwardRef<
  React.ElementRef<typeof Dropdown.RadioItem>,
  ConsoleRadioItemProps
>(function RadioItem({ id, analyticId, onSelect, ...props }, forwardedRef) {
  const uniqueID = useUniqueId();
  const itemId = id || `radioItem-${uniqueID}`;

  const onSelectHandler = event => {
    sendPendoEventDropdownItem({
      analyticId: analyticId || id,
      type: "radio"
    });

    if (onSelect) {
      onSelect(event);
    }
  };

  return (
    <Dropdown.RadioItem
      {...props}
      id={itemId}
      onSelect={onSelectHandler}
      ref={forwardedRef}
    />
  );
});

export default RadioItem;
